module.exports = __webpack_public_path__ + "img/off_line.7e0381a6.svg";